module.exports = __webpack_public_path__ + "img/197560.67ad2b5d.png";